module.exports = new __parcel__URL__("cornershop-landing.bf75d349.png").toString();